import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';
import style from './style.scss';

const propTypes = {
  title: PropTypes.string,
};

function Header({ title }) {
  return (
    <Row className={cn(style.header, 'header')}>
      <Col>
        <div className={style.text}>{title}</div>
      </Col>
    </Row>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = {
  title: '',
};

export default Header;
